
// 2. 使用 react-youtube 组件
import React, { useEffect, useRef, useState } from 'react';
import YouTube from 'react-youtube';
import { isMobileDevice } from '../../utils';

function App() {
  const playerRef: any = useRef(null);

  const [containerWidth, setContainerWidth] = useState(0);
  const containerRef: any = useRef(null);

  // 监听容器宽度变化
  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);
  const calculateHeight = () => {
    return containerWidth * 9 / 10;
  };

  const opts = {
    height: isMobileDevice() ? '204' : '433',
    width: isMobileDevice() ? '364' : '770',
    playerVars: {
      autoplay: 0,
      controls: 1,
      modestbranding: 1,
    },
    autoplay: 0, // Android 上设置为 0
    controls: 1,
    modestbranding: 1,
    playsinline: 1, // 关键设置
    rel: 0,
    showinfo: 0,
    fs: 1, // 允许全屏
    // 新增设置
    origin: window.location.origin, // 设置 origin
    enablejsapi: 1, // 启用 JS API
    widget_referrer: window.location.href, // 设置 referrer
  };

  const onReady = (event: any) => {
    playerRef.current = event.target;
  };

  const playVideo = () => {
    if (playerRef.current) {
      playerRef.current.playVideo();
    }
  };

  const pauseVideo = () => {
    if (playerRef.current) {
      playerRef.current.pauseVideo();
    }
  };
  const [isShow, setIsShow] = React.useState(false)

  return (
    <div className='w-full'>

      <div className={`${!isShow ? 'block' : 'hidden'}`}>
        <div className="w-[770px] h-[433px] relative mx-auto mt-[30px] group h5:w-[364px] h5:h-[204px]"
          onClick={() => {
            setIsShow(true)
            playVideo()
          }}
        >
          <img src={require("../../assets/image/icon4.jpg")}
            className='w-full rounded-md'
            alt="" />
          <div
            className="absolute left-0 right-0 top-0 bottom-0 bg-[#10101021] rounded-md cursor-pointer 
          hover:bg-transparent
          hover:shadow-[0_1px_15px_rgba(0,0,0,0.1)] transition-shadow duration-200"></div>
          <img src={require("../../assets/image/icon5.png")}
            className='w-[130px] h5:w-[80px] absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]
            duration-200'
            alt="" />
          {/* group-hover:hidden  */}
        </div>
      </div>

      <div className={`${isShow ? 'flex' : 'hidden'} justify-center mt-[30px] w-full`}>
        <YouTube
          videoId="m6JzvzAN6ec"
          opts={opts}
          onReady={onReady}
        />
      </div>
      {/* <button onClick={playVideo}>播放</button>
      <button onClick={pauseVideo}>暂停</button> */}
    </div >
  );
}
export default App;